import { uniq, without } from 'ramda';
import { useState } from 'react';

export type SchedulingUnavailableReason = 'DISABLED' | 'NO_DEPARTMENT' | 'NO_MARKET' | 'NO_PROVIDER' | 'NO_REASONS_NEW_PATIENTS';

export const useSchedulingUnavailableReasons = () => {
    const [schedulingUnavailableReasons, setSchedulingUnavailableReasons] = useState<SchedulingUnavailableReason[]>([]);

    const addSchedulingUnavailableReason = (newReason: SchedulingUnavailableReason) => {
        setSchedulingUnavailableReasons((prev) => uniq([...prev, newReason]));
    };

    const removeSchedulingUnavailableReason = (reasonToRemove: SchedulingUnavailableReason) => {
        setSchedulingUnavailableReasons((prev) => without([reasonToRemove], prev));
    };

    return {
        addSchedulingUnavailableReason,
        removeSchedulingUnavailableReason,
        schedulingUnavailableReasons,
    };
};
